import { Link } from "react-router-dom";
import { isPreview } from "../../hooks/useSite";

export const PreviewBanner = () =>
  isPreview() ? (
    <div data-testid="preview-banner" className="fixed top-[72px] inset-x-0 z-30 bg-[#D4AF37] text-black text-xs sm:text-sm font-semibold text-center py-2 px-4">
      Pré-visualização do rascunho — ainda não publicado.{" "}
      <Link to="/admin/conteudo" className="underline">Voltar ao painel</Link>
    </div>
  ) : null;

export const SiteLoader = () => (
  <div className="min-h-screen grid place-items-center bg-[#000000]" data-testid="site-loading">
    <img src="/img/logo-t.png" alt="Vienna Palace Hotel" className="h-20 w-auto animate-pulse" />
  </div>
);
